import { render, staticRenderFns } from "./FinishList.vue?vue&type=template&id=2bca783e&scoped=true"
import script from "./FinishList.vue?vue&type=script&lang=js"
export * from "./FinishList.vue?vue&type=script&lang=js"
import style0 from "./FinishList.vue?vue&type=style&index=0&id=2bca783e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca783e",
  null
  
)

export default component.exports